import { List } from '@shared/models/interfaces/List.interface';
import { Procedure } from '@shared/models/interfaces/procedures.interface';
export class SetProcedures {
  static readonly type = '[PROCEDURE] Set Procedures';
  constructor(public procedures: List<Procedure>) {}
}
